<div *ngIf="this.auth.trialFinishDate" class="trial-info">
  <span *ngIf="daysRemaining > 0" >
    {{'trial.daysRemaining' | translate: {number:  daysRemaining} }}
  </span>
  <span *ngIf="daysRemaining <= 0" >
    {{'trial.testEndDate' | translate}}:<br>{{auth.trialFinishDate | localizedDate}}
  </span>
</div>
